<template>
    <section class="option" :class="[typeClass, { warning: !$parent.isValid }]">
        <header class="option__header">
            <h4 class="option__title">
                {{ $parent.displayName }}
            </h4>

            <font-awesome-icon
                v-if="!$parent.isValid"
                class="option__warning"
                :icon="['fal', 'exclamation-triangle']"
            />

            <ul class="option__variants">
                <li class="option__variant">
                    <slot name="secondary" />
                </li>

                <li v-if="$slots['secondary-2']" class="option__variant">
                    <slot name="secondary-2" />
                </li>

                <li v-if="$slots['secondary-3']" class="option__variant">
                    <slot name="secondary-3" />
                </li>
            </ul>
        </header>
        <div v-if="!$parent.isValid && validationMessage" class="option__message option__message--validation">
            {{ validationMessage }}
        </div>

        <div v-if="!$parent.isValid && validationMessage" class="option__message option__message--validation">
            {{ validationMessage }}
        </div>

        <div class="option__input">
            <slot name="primary" />
        </div>

        <span v-if="message" class="option__message">
            {{ message }}
        </span>
    </section>
</template>

<script>
export default {
    name: 'toolbar-option',

    props: {
        message: {
            type: String,
            default: '',
        },

        type: {
            type: String,
            default: 'basic',
        },

        validationMessage: {
            type: String,
            default: 'This field is required',
        },
    },

    computed: {
        typeClass() {
            return `option--${ this.type }`;
        },
    },
};
</script>

<style lang="scss">
.option {
    $this: &;
    padding-left: 20px;
    padding-right: 20px;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;
    }

    &__title {
        font-weight: 700;
        font-size: 13px;
    }

    &__variants {
        margin: 0;
        padding: 0;
        display: flex;
    }

    &__variant {
        list-style: none;
    }

    &__multi {
        margin-top: 1.5rem;

        &:not(:last-of-type) {
            margin-bottom: 1rem;
        }
    }

    &__multi-label {
        display: flex;
        font-weight: 400;
        font-size: 0.75rem;
        margin-bottom: 0.5em;
        font-weight: 600;
    }

    &__input {
        padding-bottom: 15px;
        width: 100%;

        &:not(:first-of-type) {
            margin-top: 10px;
        }

        input[type="text"] {
            @extend %input;
        }

        #{ $this }__multi & {
            padding-bottom: 0;
        }

        .#{ $is-invalid } {
            border-color: $attention-color !important;
        }
    }

    &__combo-input {
        margin-top: 1em;

        input[type="text"] {
            width: 3.25em;
        }

        span {
            font-size: 0.875em;

            &:first-child { margin-right: 0.5em; }
            &:last-child { margin-left: 0.5em; }
        }
    }

    &__message {
        display: block;
        padding: 0 0 15px;
        font-size: 11px;
        width: 100%;
    }

    &__warning {
        margin-left: 5px;
    }
} // .option

.option--basic {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    input[type="color"] {
        height: 35px;
        width: 60px;
        padding: 0;
    }
}

.option--stacked {
    input[type="color"] {
        position: relative;
        width: 60px;
        height: 35px;
    }

    .option__variants {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .collapsing & {
            opacity: 0;
        }
    }

    .option__variant {
        font-size: 12px;

        &:not(:first-of-type) {
            margin-left: 12px;
        }

        input[type="color"] {
            width: 40px;
            height: 32px;
        }
    }
} // .option--stacked

.option__message--validation {
    margin-top:-10px;
}
.warning {
    > header, .option__message--validation {
        color: $attention-color;
    }

    input[type="text"], .dropdown {
        border-color: $attention-color;
    }
}

.option__message--validation {
    margin-top:-10px;
}

.warning {
    & > header, .option__message--validation {
        color: $attention-color;
    }

    input[type="text"], .dropdown {
        border-color: $attention-color;
    }
}
</style>
